import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import _variables from '@/styles/variables.scss';
export default {
  data: function data() {
    return {
      searchMenuKeywordText: '',
      filteredRoutes: [],
      searchTimer: null
    };
  },
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['permission_routes', 'sidebar', 'menus'])), {}, {
    routes: function routes() {
      return this.$router.options.routes;
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  watch: {
    searchMenuKeywordText: function searchMenuKeywordText() {
      this.debounceSearch();
    }
  },
  methods: {
    handleSearchMenu: function handleSearchMenu() {
      if (this.searchMenuKeywordText.trim() === '') {
        this.$message({
          message: '请输入搜索菜单关键字',
          type: 'warning'
        });
        return;
      }
      var keyword = this.searchMenuKeywordText.trim().toLowerCase();
      var filteredRoutes = this.filterRoutes(this.permission_routes, keyword);
      // console.log('搜索菜单关键字:', this.searchMenuKeywordText)
      // console.log('过滤后的菜单:', filteredRoutes)
      this.filteredRoutes = filteredRoutes;
    },
    debounceSearch: function debounceSearch() {
      var _this = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      if (this.searchMenuKeywordText.trim() === '') {
        this.filteredRoutes = [];
        return;
      }
      this.searchTimer = setTimeout(function () {
        _this.handleSearchMenu();
      }, 1000);
    },
    filterRoutes: function filterRoutes(routes, keyword) {
      var result = [];
      var _iterator = _createForOfIteratorHelper(routes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var route = _step.value;
          if (this.routeMatches(route, keyword)) {
            result.push(_objectSpread({}, route));
          } else if (route.children && route.children.length > 0) {
            var filteredChildren = this.filterRoutes(route.children, keyword);
            if (filteredChildren.length > 0) {
              result.push(_objectSpread(_objectSpread({}, route), {}, {
                children: filteredChildren
              }));
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    },
    routeMatches: function routeMatches(route, keyword) {
      var name = (route.name || '').toString().toLowerCase();
      var path = (route.path || '').toString().toLowerCase();
      var metaTitle = (route.meta && route.meta.title || '').toString().toLowerCase();
      return name.includes(keyword) || path.includes(keyword) || metaTitle.includes(keyword);
    }
  },
  mounted: function mounted() {
    // setTimeout(() => {
    // 	// console.log(this.permission_routes, '77')
    // }, 4000)
  }
};